"use strict";

import $ from "jquery";

const toggleCountryList = function () {
  $("#region-search").toggleClass("expanded");
};

$(document).on("turbolinks:load", function () {
  $.extend(true, {}, window.ExternalDataCardGrid).setupForMarketsPage();
  $("#country-list-toggle").on("click", toggleCountryList);
});
